// extracted by mini-css-extract-plugin
export var active = "_dr-7";
export var container = "_dr-0";
export var evenWidth = "_dr-4";
export var large = "_dr-5";
export var outlet = "_dr-8";
export var slide = "_dr-2";
export var small = "_dr-6";
export var tab = "_dr-3";
export var tabs = "_dr-1";